import { render, staticRenderFns } from "./AdminAcquisitionStates.vue?vue&type=template&id=0649a338&"
import script from "./AdminAcquisitionStates.vue?vue&type=script&lang=js&"
export * from "./AdminAcquisitionStates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports